import React, { Suspense, lazy } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Routes, BrowserRouter, } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import 'tailwindcss/tailwind.css';
import { store } from './redux/store';
import './index.css';
import '../assets/fonts/fonts.css';
import Spinner from './components/Spinner';
var App = lazy(function () { return import('./views/App'); });
import Auth from './views/Auth';
import LoadingLayer from './components/LoadingLayer';
import Maintenance from './views/Maintenance';
import { ToastContainer } from './components/Toast';
import DiscontinuationBanner from './components/DiscontinuationBanner';
var loading = document.createElement('div');
loading.id = 'loading';
document.body.appendChild(loading);
var modal = document.createElement('div');
modal.id = 'modal';
document.body.appendChild(modal);
var lightbox = document.createElement('div');
lightbox.id = 'lightbox';
document.body.appendChild(lightbox);
var root = document.createElement('div');
root.id = 'root';
document.body.appendChild(root);
var ELECTRON_TITLEBAR_HEIGHT_PX = window.electron ? 28 : 0;
var DISCONTINUATION_BANNER_HEIGHT_PX = 56;
document.documentElement.style.setProperty('--app-titlebar-height', "".concat(ELECTRON_TITLEBAR_HEIGHT_PX, "px"));
document.documentElement.style.setProperty('--app-discontinuation-banner-height', "".concat(DISCONTINUATION_BANNER_HEIGHT_PX, "px"));
document.documentElement.style.setProperty('--app-top-banner-offset', "".concat(ELECTRON_TITLEBAR_HEIGHT_PX + DISCONTINUATION_BANNER_HEIGHT_PX, "px"));
render(React.createElement(React.StrictMode, null,
    React.createElement(Provider, { store: store },
        React.createElement(BrowserRouter, { basename: '/dashboard' },
            React.createElement(Suspense, { fallback: React.createElement("div", { className: 'flex h-screen w-full items-center justify-center' },
                    React.createElement(Spinner, null)) },
                React.createElement("div", { className: 'dark' },
                    window.electron ? (React.createElement("div", { className: 'webkit-app-drag fixed h-7 w-full' })) : (React.createElement(React.Fragment, null)),
                    React.createElement(DiscontinuationBanner, null),
                    React.createElement(ToastContainer, null),
                    React.createElement(LoadingLayer, null),
                    process.env.MAINTENANCE_MODE ? (React.createElement(Maintenance, null)) : (React.createElement(Routes, null,
                        React.createElement(Route, { path: '/*', element: React.createElement(DndProvider, { backend: HTML5Backend },
                                React.createElement(App, null)) }),
                        React.createElement(Route, { path: 'auth/*', element: React.createElement(Auth, null) })))))))), document.querySelector('#root'));
